import { ScreenRotation } from '@material-ui/icons';
import { useCitrusView } from '../../contexts/CitrusViewContext';

interface Props {
  isPortrait: boolean;
}

export const RotateDeviceTag = ({ isPortrait }: Props) => {
  const { isMobile } = useCitrusView();
  if (isPortrait === false && isMobile === false) return null;

  return (
    <p className="animate-bounce align-center text-xs py-1 px-2 rounded-full bg-amber-200 text-amber-900 m-2 whitespace-nowrap">
      <span className="animate-bounce mr-1">
        <ScreenRotation />
      </span>
      Rotate Device for Mobile View
    </p>
  );
};
